import { DialogTitle, DialogContent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import SchedulingDetails from './SchedulingDetails';

export default function SchedulingStep() {
    return (
        <>
            <DialogTitle>Scheduling</DialogTitle>
            <DialogContent>
                <Grid container spacing={1} padding={2} paddingTop={1} alignItems={'flex-start'}>
                    <SchedulingDetails />
                </Grid>
            </DialogContent>
        </>
    );
}
